// extracted by mini-css-extract-plugin
export var textInput = "_cj-0";